import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import { sp } from '@/theme/mui';

export const Content = ({ content }: ContentProps) => {
  return (
    <Box sx={{ py: sp[12], '@media (min-width: 600px)': { py: sp[32] } }}>
      {content}
    </Box>
  );
};

interface ContentProps {
  content?: ReactNode;
}

Content.displayName = 'Content';

export default Content;
